<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFolderPlusOutline } from "@mdi/js";
export default {
  name: "MdiFolderPlusOutline",
  data() {
    return {
      svgPath: mdiFolderPlusOutline,
    };
  },
};
</script>
